import { rememberLeadNavigation } from './leadWorkspaceMemory.js';

/** A global destination is a fresh visit, even when its URL is already active. */
export function navigateFromSideNav(route, router, reloadCurrentRoute) {
  if (!route) return;
  const path = route.startsWith('/') ? route : `/${route}`;
  rememberLeadNavigation(path);
  if (path === '/leads' && window.location.hash.replace(/\/$/, '') === '#/leads') {
    // Navigo's "already" lifecycle skips the handler for the current URL.
    // Reuse the app's guarded re-resolution path so Leads can consume the visit.
    reloadCurrentRoute();
  } else {
    router.navigate(path);
  }
}
